import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/social/instagram.png'
import _imports_2 from '@/assets/images/social/pinterest.png'
import _imports_3 from '@/assets/images/social/telegram.png'


const _withScopeId = n => (_pushScopeId("data-v-05afc548"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer container" }
const _hoisted_2 = { class: "footer__links-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "footer__logo",
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_4 = {
  class: "footer__links links",
  id: "contacts"
}
const _hoisted_5 = { class: "links__item" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<li class=\"links__item\" data-v-05afc548><a href=\"https://www.instagram.com/form.aart?igsh=MTgxb2V6b3dwcnkwcQ%3D%3D&amp;utm_source=qr\" target=\"_blank\" data-v-05afc548><div class=\"links__item-icon-wrapper\" data-v-05afc548><img src=\"" + _imports_1 + "\" alt=\"instagram\" data-v-05afc548> * </div> Instagram </a></li><li class=\"links__item\" data-v-05afc548><a href=\"https://pin.it/51y4GZJvf\" target=\"_blank\" data-v-05afc548><img src=\"" + _imports_2 + "\" alt=\"pinterest\" data-v-05afc548> Pinterest </a></li><li class=\"links__item\" data-v-05afc548><a href=\"https://t.me/formaartdsn\" target=\"_blank\" data-v-05afc548><img src=\"" + _imports_3 + "\" alt=\"telegram\" data-v-05afc548> Telegram </a></li><li class=\"links__item\" data-v-05afc548><a href=\"mailto:FormaArt.des@yandex.com\" data-v-05afc548>Оставить сообщение</a></li>", 4)
const _hoisted_10 = { class: "footer__privacy privacy" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Политика конфиденциальности", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "privacy__annotation" }, " *Принадлежит компании Meta, которая признана экстремистской организацией и запрещена на территории России ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "footer__logo-wrapper",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, { to: "/projects" }, {
            default: _withCtx(() => [
              _createTextVNode("Портфолио")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", {
          class: "links__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToBlock('faq')))
        }, "Faq"),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        class: "privacy__link",
        to: "/privacy-policy"
      }, {
        default: _withCtx(() => [
          _hoisted_11,
          _createTextVNode(" © 2018—" + _toDisplayString(_ctx.currentYear), 1)
        ]),
        _: 1
      }),
      _hoisted_12
    ])
  ]))
}